/**
 * Constants for invoice panel status values
 */
export const INVOICE_STATUS = {
  DEFAULT: 'default',
  NOT_AVAILABLE: 'not_available',
  REQUESTED: 'requested',
  SENT: 'sent',
}

/**
 * Possible status values for the invoice panel
 */
export type InvoicePanelStatus = (typeof INVOICE_STATUS)[keyof typeof INVOICE_STATUS]

/**
 * Props for the main InvoicePanel component
 */
export interface InvoicePanelProps {
  hash: string
  status?: InvoicePanelStatus
  date?: string
}
